import styled from '@emotion/styled';
import { useTranslation } from '@/lib/i18n';
import { SKIP_TO_CONTENT_LABEL } from './i18.keys';

const SkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  z-index: 9999;
  padding: 0.5rem 1rem;
  background: #000;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  transition: top 0.1s ease-in-out;

  &:focus {
    top: 0;
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
`;

/** Skip link — first tab stop; jumps keyboard users past chrome to main content. */
export function SkipToContent() {
  const { t } = useTranslation();
  return <SkipLink href="#main-content">{t(SKIP_TO_CONTENT_LABEL)}</SkipLink>;
}
